import { render } from "./not-found.vue?vue&type=template&id=5a3f1469&scoped=true&ts=true"
import script from "./not-found.ts?vue&type=script&lang=ts&external"
export * from "./not-found.ts?vue&type=script&lang=ts&external"

import "./not-found.scss?vue&type=style&index=0&id=5a3f1469&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3f1469"]])

export default __exports__